import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "trash",
  "use": "trash-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"trash\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 4v.5h4.5a.5.5 0 01.5.5v.5a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5V5a.5.5 0 01.5-.5H10V4a1 1 0 011-1h2a1 1 0 011 1zM6 20.5V8h12v12.5a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 016 20.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol